import React, { createContext, useEffect } from 'react'
import {
    displayValues,
    formValues,
} from '../../Store/reducers/formReducer/initialState'
import styles from './StepContainer.module.css'
import { StepContainerProps, StepContextType } from './types'
import { getSteps } from './Steps'
import { getJobSeekerSteps } from './JobSeekerSteps'
import { StepWrapper } from './StepWrapper'
import { stepStatus } from '../../Store/reducers/stepReducer/initialState'

export const StepContext = createContext<StepContextType>({
    formState: formValues,
    displayState: displayValues,
    currentStep: 0,
    stepBoolean: stepStatus,
    handleNext: () => {},
    handlePrev: () => {},
    setFormValue: () => {},
    updateUserResume: () => {},
    setDisplayValue: () => {},
    setStepStatus: () => {},
    setSkippedSteps: () => {},
    skippedSteps: [],
    webhook: '',
    isBlocking: false,
    testPattern: 'A',
    registerToken: undefined,
    offerId: undefined,
    handleRegistration: () => Promise.resolve({ status: '' }),
})

// 全ステップが同時にDOMへ描画されるため、表示中ステップ限定の挙動を全体のcurrentStepで
// 判定すると、スライドで出ていく側まで遷移中に巻き込まれる。各ステップに自分のindexを
// 配り、自身の位置だけで判定できるようにする
export const StepIndexContext = createContext(0)

export const StepContainer = ({
    stepState,
    displayState,
    formState,
    handleNext,
    handlePrev,
    setFormValue,
    updateUserResume,
    setDisplayValue,
    setStepStatus = () => {},
    setSkippedSteps = () => {},
    webhook,
    isBlocking,
    testPattern = 'A',
    registerToken,
    offerId,
    handleRegistration,
}: StepContainerProps) => {
    useEffect(() => {
        const handleGlobalTab = (e: KeyboardEvent) => {
            if (e.key === 'Tab') {
                e.preventDefault()
            }
        }

        document.addEventListener('keydown', handleGlobalTab)

        return () => {
            document.removeEventListener('keydown', handleGlobalTab)
        }
    }, [])

    const Steps = registerToken ? getJobSeekerSteps() : getSteps(testPattern)

    const getStepComponent = (index: number) => {
        return Steps[index].Component
    }

    return (
        // DEV-3482: 配信中のパターンの目印。CSSからは参照せず、E2Eと画面確認で使う
        <div data-ab-pattern={testPattern}>
            {isBlocking && <div className={styles.blockingOverlay} />}

            <StepContext.Provider
                value={{
                    formState,
                    displayState,
                    currentStep: stepState.currentStep.currentStep,
                    stepBoolean: stepState.stepStatus,
                    handleNext,
                    handlePrev,
                    setFormValue,
                    updateUserResume,
                    setDisplayValue,
                    setStepStatus,
                    setSkippedSteps,
                    skippedSteps: stepState.skippedSteps,
                    webhook,
                    isBlocking,
                    testPattern,
                    registerToken,
                    offerId,
                    handleRegistration,
                }}
            >
                <StepWrapper currentStep={stepState.currentStep.currentStep}>
                    {Steps.map((_, index) => {
                        const Component = getStepComponent(index)
                        return (
                            <div key={index} className={styles.stepContent}>
                                <StepIndexContext.Provider value={index}>
                                    <Component />
                                </StepIndexContext.Provider>
                            </div>
                        )
                    })}
                </StepWrapper>
            </StepContext.Provider>
        </div>
    )
}
